import React, { useEffect, useState } from "react";
import { Table, Button, Container, Form, Modal } from "react-bootstrap";
import { PencilSquare, Trash, Check, X } from "react-bootstrap-icons";


// ------------ Page Imports ---------------

import "../../../App.css";
import SideMenu from "../../../Components/SideDrawer";
import PageHeader from "../../../Components/Header";
import { companyDelete, companyEdit, companyGet, companyPost } from "../../../Api/Admin/AdminApi";
import { extractErrorMessage } from "../../../Utils/ErrorUtlis";



const Organization = () => {

  const [apiData, setApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    status: 1
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleitingId, setDeletingId] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editFormData, setEditFormData] = useState({
    name: "",
    description: ""
  });


  useEffect(() => {
    console.log(`Inside the useEffect`);
    const fetchData = async () => {
      console.log(`Inside the Fetch data`);
      try {
        console.log(`Inside the try block`);

        const data = await companyGet();
        if (data) {
          console.log(`Inside the if statement`);

          const company = data.map(i => ({
            id: i._id,
            name: i.name,
            description: i.description,
            status: i.status
          }));
          setApiData(company);
          setIsLoading(false);
          console.log(`API Data ${JSON.stringify(apiData)}`);  // Under Production         
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchData();
  }, [])

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async () => {
    try {
      const response = await companyPost(formData);
      if (response) {
        <div className="alert" role="alert">
          New Organization Created..
        </div>
        window.location.reload();
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }


  const handleEditClick = (organizationData) => {
    setEditingId(organizationData.id);
    setEditFormData({
      name: organizationData.name,
      description: organizationData.description,
      status: organizationData.status
    });
  };
  const handleCancelClick = () => {
    setEditingId(null);
  }


  const handleEditFormChange = (event) => {
    const { name, value } = event.target;
    setEditFormData({
      ...editFormData,
      [name]: value
    });
  };

  const handleSaveClick = async (id) => {
    setEditingId(null)
    try {
      const response = await companyEdit(editFormData, id);
      if (response) {
        // setEditingId(null)
        window.location.reload();
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await companyDelete(id);
      if (response) {
        setDeletingId(null);
        window.location.reload();
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader
          title="Organization"
          showButtons={true}
        />
        <h4 className="mb-4 d-flex justify-content-between align-items-center">
          Organization Details
          <Button variant="primary" className="d-flex align-items-center" onClick={() => setShowAddModal(true)}>
            Create+
          </Button>
        </h4>
        {isLoading ? <div class="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div> :
          <div style={{ overflow: 'auto' }}>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {apiData.map((org, i) => (
                  <tr key={org.id}>
                    <td>{editingId === org.id ? (
                      <Form.Control
                        type="text"
                        name="name"
                        value={editFormData.name}
                        onChange={handleEditFormChange}
                      />
                    ) : (
                      org.name
                    )}</td>
                    <td>{editingId === org.id ? (
                      <Form.Control
                        as="textarea"
                        name="description"
                        value={editFormData.description}
                        onChange={handleEditFormChange}
                      />
                    ) : (
                      org.description
                    )}</td>
                    <td>
                      {editingId === org.id ? (
                        <>
                          <Button
                            variant="success"
                            size="sm"
                            className="me-2"
                            onClick={() => handleSaveClick(org.id)}
                          >
                            <Check />
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={handleCancelClick}
                          >
                            <X />
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="me-2"
                            onClick={() => handleEditClick(org)}
                          >
                            <PencilSquare />
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => {
                              setDeletingId(org.id);
                              setShowDeleteModal(true);
                            }}
                          >
                            <Trash />
                          </Button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        }
        <Modal show={showAddModal} onHide={() => setShowAddModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Create New Organization</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleFormChange}
                  required
                ></Form.Control>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Description *</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  value={formData.description}
                  onChange={handleFormChange}
                  required
                ></Form.Control>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="warning" onClick={() => setShowAddModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSubmit}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Congirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are You Want to delete This Organization?..</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>NO</Button>
            <Button variant="warning" onClick={() => {
              handleDelete(deleitingId);
              setShowDeleteModal(false);
            }}>YES</Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  )
};

export default Organization;